// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__387hL","unreadBadge":"styles_unreadBadge__5oBho","modalContent":"styles_modalContent__28BpI","modal":"styles_modal__36RLI"};